import { render, staticRenderFns } from "./CompetitionApplicationsAssessors.vue?vue&type=template&id=7225bde4&"
import script from "./CompetitionApplicationsAssessors.vue?vue&type=script&lang=js&"
export * from "./CompetitionApplicationsAssessors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports